export default __webpack_public_path__ + "static/media/xcKSM.26678228.png";